import {ProviderStatusEnum} from "@/enums/providerStatusEnum";

export function getProviderStatusIndicator(providerStatus: number): string {
  const providerStatusEnum = providerStatus as ProviderStatusEnum;
  switch(providerStatusEnum) {
    case ProviderStatusEnum.PROSPECT:
      return `<span class="icon-custom-pending status-icon text-yellow"></span>`;
    case ProviderStatusEnum.ACTIVE:
      return `<span class="icon-custom-active status-icon text-green"></span>`;
    case ProviderStatusEnum.INACTIVE:
      return `<span class="icon-custom-inactive status-icon text-gray"></span>`;
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/providers/ProviderSearchResultModel.ts